import "./EditImage.scss";
import { useEffect, useState, Fragment } from "react";
import { API_URL } from "../../utils/axios";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import { Redirect } from "react-router-dom";

const EditImage = (props) => {
  const [description, setDescription] = useState(true);
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState();
  const [deleted, setDeleted] = useState(false);

  const fetchGalleryItem = (props) => {
    axios
      .get(API_URL + "/gallery/" + props.match.params.id)
      .then((response) => {
        setDescription(response.data.description);
        setImage(response.data.picture);
        setLoading(false);
      })
      .catch((error) => setDeleted(true));
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(API_URL + "/gallery/" + props.match.params.id, {
        picture: image,
        description,
      })
      .then((response) => {
        window.location = "/gallery/" + props.match.params.id;
      })
      .catch((error) => console.log(error));
  };

  const handleDelete = () => {
    axios
      .delete(API_URL + "/gallery/" + props.match.params.id)
      .then((response) => {
        setDeleted(true);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    setDeleted(false);
    fetchGalleryItem(props);
  }, [setImage, props, setDeleted]);

  if (loading) {
    return <Loading />;
  }
  if (deleted) {
    return <Redirect to="/gallery/?deleted=true" />;
  }

  return (
    <div>
      {!loading && (
        <Fragment>
          <div className="edit-image">
            <div className="edit-image__left">
              <img src={image} alt="gallery-item" className="edit-image__img" />
            </div>
            <form className="edit-image__right" onSubmit={handleSubmit}>
              <div className="edit-image__description">
                <textarea
                  name="description"
                  defaultValue={description}
                  onChange={handleDescriptionChange}
                  className="edit-image__textarea"
                ></textarea>
              </div>
              <div className="edit-image__buttons">
                <button type="submit" className="edit-image__submit">
                  SUBMIT
                </button>
                <button className="edit-image__delete" onClick={handleDelete}>
                  DELETE
                </button>
              </div>
            </form>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default EditImage;
